import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const ORGANIZATION_DELETE = gql(`
  mutation organizationDelete($organizationId: ID!){
    organizationDelete(organizationId: $organizationId) {
      __typename
      ... on OrganizationDeleted {
        __typename
        id
      }
      ... on OrganizationHasApps {
        __typename
        id
      }
      ... on OrganizationHasInboundSubscriptions {
        __typename
        id
      }
      ... on OrganizationNotFound {
        __typename
        id
      }
    }
  }
`);

export function useOrganizationDelete() {
  return useMutation(ORGANIZATION_DELETE);
}
